(($) => {
  console.log('Init Block: Brochure');

  Formstone.Ready(() => {

    let $brochures = $('.js-brochure');

    // Cache the target to avoid DOM queries
    $brochures.each((index, el) => {
      let $el = $(el);
      let $items = $el.find('.js-brochure_item');
      let group = $(el).attr('id');

      if ($items.length) {
        let html = '<div class="brochure_tabs">';

        $items.each((index, el) => {
          let $el = $(el);
          let label = $el.data('label');
          let id = $el.attr('id');
          let hash = label.trim().toLowerCase().replace(/\s/g, '-');

          html += '<a href="#' + id + '" class="brochure_tab js-brochure_tab js-no_scroll_to" data-tabs-group="' + group + '-tabs" data-tabs-hash="' + hash + '">' + label + '</a>';
        });

        html += '</div>';

        $el.prepend(html);
        $el.find('.js-brochure_tab').tabs({
          mobileMaxWidth: '740px',
        }).on('update.tabs', (e) => {
          // Set hash on click
          window.location.hash = $(e.currentTarget).data('tabs-hash');
        });

        $el.on('click', '.fs-tabs-tab_mobile', (e) => {
          window.scrollToElement($(e.currentTarget));
        });
      }
    });

    // Check url on load

    let hash = window.location.hash;

    if (hash !== '') {
      let $target = $('[data-tabs-hash="' + hash.replace('#', '') + '"]');

      $target.trigger('click');

      if ($target.is(':visible')) {
        window.scrollToElement($target);
      } else {
        let $mobileTarget = $('.fs-tabs-tab_mobile.' + $target.attr('id'));

        window.scrollToElement($mobileTarget);
      }
    }

  });

})(jQuery);